const o = 37, t = 38, c = 39, n = 40, s = 13, E = 27, T = 32, A = 9;
export { n as DOWN, s as ENTER, E as ESC, o as LEFT, c as RIGHT, T as SPACE, A as TAB, t as UP };
